import React from 'react';
import { useRecoilValue } from 'recoil';

import { getCarriersByIdsState } from '@/state/carriers';
import { getCarrierName } from '@/utils/carrier';
import { getPreferredIdentifier } from '@/utils/helpers';
import { tv } from '@/utils/styles';

export interface CarrierNameListProps {
  carrierIds: string[];
}

const CarrierNameList = ({ carrierIds }: CarrierNameListProps) => {
  const carriers = useRecoilValue(getCarriersByIdsState(carrierIds));
  const carrierPreferredIds = carriers
    .map((carrier) => getPreferredIdentifier(carrier.identifiers)?.value)
    .filter(Boolean);

  return (
    <p className={styles()}>
      {carrierPreferredIds.length > 1 ? carrierPreferredIds.join(', ') : getCarrierName(carriers[0])}
    </p>
  );
};

const styles = tv({
  base: 'mb-0 ml-0 mr-0 mt-1 overflow-hidden overflow-ellipsis whitespace-nowrap text-sm italic text-text-secondary',
});

export { CarrierNameList };
